module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "contact"
  }, [_c('h3', [_vm._v("Contact")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('dt', [_vm._v("Twitter")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://twitter.com/trippysalmon"
    }
  }, [_vm._v("@trippysalmon")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1498b3fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 529
// module chunks = 1